import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {StatusBadge} from '../status-badge/status-badge';
import type {StatusBadgeProps} from '../status-badge/status-badge';

import styles from './status-bar.module.css';

export type StatusBarProps = {
    isLoading?: boolean;
    status?: StatusBadgeProps | null | undefined;
    primaryText: string | null | undefined | React.ReactNode;
    secondaryText?: string | React.ReactNode;
};

export function StatusBar(props: StatusBarProps) {
    if (props.isLoading) {
        return null;
    }

    return (
        <StackLegacy isHorizontal={true} spacing={16} alignCenter={true}>
            <div className='flex flex-dir-col justify-center'>
                <div className={styles['primary-text-container']}>{props.primaryText}</div>
                {props.secondaryText && (
                    <div className={styles['secondary-text']}>{props.secondaryText}</div>
                )}
            </div>
            {props.status && <StatusBadge {...props.status} />}
        </StackLegacy>
    );
}
